export default "/_next/static/images/db381e01e644279ceca19a6f4e434d4e.jpg";